import {
    IBadgeType,
} from '../../types';

export function formatText(type: IBadgeType, currentSeconds: number): string {
    switch (type) {
        case 'SUCCESS': {
            return 'Paid';
        }
        case 'FAILED': {
            return 'Failed';
        }
        case 'PENDING': {
            return 'Checking';
        }
        case 'TIMER': {
            const minutes = Math.floor(currentSeconds / 60);
            const seconds = currentSeconds % 60;

            return `${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')} left`;
        }
    }
}
